import { shouldAddItem } from "../utilities/shouldAddItem.js";
import { sourceItemToExtendedSourceItem } from "./sourceItemToExtendedSourceItem.js";
export async function appendSource(fileCollection, source, options = {}) {
    const { options: { filter }, } = fileCollection;
    const { entries, baseURL } = source;
    const promises = [];
    for (const entry of entries) {
        const { relativePath } = entry;
        if (!shouldAddItem(relativePath, filter))
            continue;
        const alternativeBaseURL = baseURL || options.baseURL;
        const source = sourceItemToExtendedSourceItem(entry, alternativeBaseURL);
        promises.push(fileCollection.appendExtendedSource(source));
    }
    await Promise.all(promises);
}
//# sourceMappingURL=appendSource.js.map